// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2LeMF","text":"style_text__12NX9","point":"style_point__1rmjS","point__green":"style_point__green__1UIKe","point__red":"style_point__red__2I5rp"};